'use strict';

angular.module('MoreAppsServices').factory('$adminUsersSyncService', ['moreConstants', '$resource', function (moreConstants, $resource) {

  const AdminSyncBucketState = $resource(moreConstants.adminApiEndpoint + '/admin/sync/:userId/bucketstate', {userId: '@userId'}, {
    get: {
      method: 'GET'
    }
  });

  const AdminSyncBucketData = $resource(moreConstants.adminApiEndpoint + '/admin/sync/:userId/bucketdata/:operationId', {
    userName: '@userId',
    operationId: '@operationId'
  }, {
    get: {
      method: 'GET'
    }
  });

  return {
    getBucketState: (userId) => AdminSyncBucketState.get({userId}),
    getBucketData: (userId, operationId) => AdminSyncBucketData.get({userId, operationId}),
  };
}]);
